<template>
    <div>
        <!-- Modal Remarcação de Combo -->
        <div class="modal fade" id="remarcarComboModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Remarcar</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!dados" />

                        <div v-else>
                            <div class="mb-3">
                                <div class="lead">
                                    {{ dados.nome_paciente }}
                                </div>
                            </div>

                            <div class="alert alert-warning" v-if="dados && dados.blockrepetir === false">
                                Remarcar essa sessão e as sessões a partir dessa
                            </div>

                            <div class="alert alert-warning" v-if="dados && dados.blockrepetir === true">
                                Remarcar APENAS essa sessão 
                            </div>

                            <div v-if="dados.cc" class="mb-3">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text">
                                            <input type="radio" value="S" v-model="medico_agendar">
                                        </div>
                                    </div>
                                    <label class="form-control">Profissional Selecionado</label>
                                </div>
                                <div class="input-group mt-1">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text">
                                            <input type="radio" value="Q" v-model="medico_agendar">
                                        </div>
                                    </div>
                                    <label class="form-control">Outro Profissional</label>
                                </div>

                                <template v-if="medico_agendar == 'Q'">
                                    <div class="row mt-3">
                                        <div class="col col-12">
                                            <az-input
                                                label="Médico"
                                                type="autocomplete" 
                                                placeholder="Selecione..."
                                                optionsMode="aql"
                                                service="medicos.index"
                                                optionsName="medicos-cadastro"
                                                :optionsParm="{ ativos: true }"
                                                v-model="dados.outro_medico" />
                                        </div>
                                    </div>
                                </template>
                            </div>
                            
                            <div class="card mb-0">
                                <div class="card-header d-flex justify-content-between">
                                    <div class="d-flex">
                                        <input type="checkbox" checked disabled class="mr-3">
                                        <div>
                                            <div>
                                                {{ dados.procedimento.search }}
                                                <span class="badge badge-primary ml-2" v-if="dados.outros_proc">
                                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                                    {{ dados.outros_proc }}
                                                </span>
                                            </div>
                                            <div class="small text-muted" v-if="dados.medico">
                                                {{ dados.medico.search }}
                                                <span class="badge badge-light ml-2" v-if="dados.unidade_operacao && dados.unidade_operacao.st_sigla">
                                                    {{ dados.unidade_operacao.st_sigla }}
                                                </span>
                                            </div>
                                            <div class="small text-muted">
                                                {{ $util.getFormatDate(dados.dt_inicio) }}
                                                {{ dados.dt_inicio.substr(11,5) }}
                                                <span class="ml-3">
                                                    {{ $util.getFormatDate(dados.dt_inicio, 'dddd') }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <span class="ml-4" v-if="dados.outros_proc">
                                            <input type="checkbox" v-model="dados.desagrupar" class="mr-2">
                                            Desagrupar
                                        </span>
                                    </div>
                                </div>
                                <ul class="list-group">
                                    <li class="list-group-item" v-for="(outra, iox) in lista_outras" :key="iox">
                                        <div class="d-flex justify-content-between">
                                            <div class="d-flex">
                                                <input type="checkbox" v-model="outra.id_atendimento" class="mr-3">
                                                <div>
                                                    <div>
                                                        {{ outra.procedimento.search }}
                                                        <span class="badge badge-primary ml-2" v-if="outra.outros_proc">
                                                            <i class="fa fa-plus" aria-hidden="true"></i>
                                                            {{ outra.outros_proc }}
                                                        </span>
                                                    </div>
                                                    <div class="small text-muted">
                                                        {{ outra.medico.search }}
                                                        <span class="badge badge-light ml-2" v-if="outra.unidade_operacao && outra.unidade_operacao.st_sigla">
                                                            {{ outra.unidade_operacao.st_sigla }}
                                                        </span>
                                                    </div>
                                                    <div class="small text-muted">
                                                        {{ $util.getFormatDate(outra.dt_inicio) }}
                                                        {{ outra.dt_inicio.substr(11,5) }}
                                                        <span class="ml-3">
                                                            {{ $util.getFormatDate(outra.dt_inicio, 'dddd') }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <span class="ml-4" v-if="outra.outros_proc">
                                                    <input type="checkbox" v-model="outra.desagrupar" class="mr-2">
                                                    Desagrupar
                                                </span>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>

                            <div v-if="dados.js_outros_campos && dados.js_outros_campos.id_regiao_cd" class="mt-3">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Remarcar como coleta domiciliar"
                                    v-model="dados.manter_coleta_dom" />
                            </div>

                            <div class="form-row mt-3" v-else-if="dados && !dados.cc && !dados.infusao">
                                <div class="col col-12">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Marcar para mesma unidade"
                                        v-model="dados.manter_mesma_unidade" />
                                </div>
                            </div>
                        </div>

                        <pre v-if="false">{{ dados }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-success" @click="selecionar()">Remarcar Selecionados</button>
                        <button type="button" class="btn btn-outline-success" @click="selecionar(true)" v-if="lista_outras.length">Remarcar Todos</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data () { 
        return { 
            dados: null, 
            medico_agendar: 'S'
        }
    },

    components: { 
        AzEmptyState, 
        AzInput, 
    }, 

    computed: { 
        lista_outras: function () { 
            if ( !this.dados )
                return [];

            let lista = ( this.dados.outras && this.dados.outras.length ) 
                ? this.dados.outras
                : ( this.dados.outras_cad_temp ? this.dados.outras_cad_temp : [] );

            return lista; //.filter(item => !item.id_atendimento);
        }
    },

    methods: { 
        remarcar (id_marcacao, trocarMedico = false, outros_parms = null) { 
            this.dados = null;
            if ( !outros_parms ) { 
                outros_parms = {};
            }

            if ( trocarMedico ) { 

                if ( this.$route.path == '/call-center') { 
                    this.$router.push({ path: '/' })
                        .then(() => { 
                            this.$router.push({
                                name: "call-center",
                                params: {
                                    remarcacao: id_marcacao,
                                    trocarmedico: trocarMedico
                                },
                                trocarmedico: trocarMedico
                            });
                        });
                } else if ( this.$route.path == '/infusao/confirmacao' ) { 

                    this.$router.push({
                        name: "infusao",
                        params: {
                            remarcacao: id_marcacao,
                            trocarmedico: trocarMedico,
                            aba: 'marcacao'
                        },
                        trocarmedico: trocarMedico
                    });

                } else { 
                    
                    this.$router.push({
                        name: "call-center",
                        params: {
                            remarcacao: id_marcacao,
                            trocarmedico: trocarMedico
                        },
                        trocarmedico: trocarMedico
                    });

                }

            }

            $('#remarcarComboModal').modal('show');

            this.$util.load(this, { 
                service: 'marcacoes',
                func: 'show', 
                parms: { 
                    id: id_marcacao,
                    buscar_outras: true, 
                    tempo_remarcacao: 3, 
                },
                loadTo: res => { 
                    if ( res.js_outros_campos && res.js_outros_campos.id_regiao_cd ) { 
                        res.manter_coleta_dom = true;
                    }

                    if ( res.outras && res.outras.length ) { 
                        res.outras = res.outras.filter(item => !item.id_atendimento);
                    }

                    if ( res && outros_parms ) { 
                        this.dados = { 
                            ...res,
                            ...outros_parms,
                        };
                    } else { 
                        this.dados = res;
                    }
                    
                }
            });
        },

        selecionar (todas = false) { 

            $('#remarcarComboModal').modal('hide');

            let lista = [this.dados.id_marcacao].concat(
                this.lista_outras.filter(item => todas || item.id_atendimento)
                    .map(item => item.id_marcacao)
            );

            let desagrupar = [this.dados.desagrupar].concat(
                this.lista_outras.filter(item => todas || item.id_atendimento)
                    .map(item => item.desagrupar)
            );

            this.$nextTick(() => { 

                if ( this.dados.cc ) { 

                    this.$nextTick(() => {
                        this.$router.push({
                            name: "centro-cirurgico",
                            params: { 
                                aba: 'marcacao', 
                                remarcacao: lista,
                                desagrupar: desagrupar,
                                medico: this.medico_agendar == 'Q'
                                    ? this.dados.outro_medico
                                    : this.dados.medico
                            }
                        });
                    });

                    return;

                } else if ( this.dados.infusao ) { 

                    this.$router.push({ path: '/' })
                        .then(() => { 
                            this.$router.push({
                                name: "infusao",
                                params: { 
                                    aba: 'marcacao', 
                                    remarcacao: lista,
                                    desagrupar: desagrupar,
                                    medico: this.medico_agendar == 'Q'
                                        ? this.dados.outro_medico
                                        : this.dados.medico
                                }
                            });
                        });

                    return;

                }

                if ( this.$route.path == '/call-center') { 
                    this.$router.push({ path: '/' })
                        .then(() => { 
                            this.$router.push({
                            name: "call-center",
                            params: {
                                remarcacao: lista,
                                desagrupar: desagrupar,
                                manter_coleta_dom: this.dados.manter_coleta_dom, 
                                manter_mesma_unidade: this.dados.manter_mesma_unidade,
                                blockrepetir: this.dados.blockrepetir
                            },
                        });
                    });
                } else { 
                    this.$router.push({
                        name: "call-center",
                        params: { 
                            remarcacao: lista,
                            desagrupar: desagrupar,
                            manter_coleta_dom: this.dados.manter_coleta_dom, 
                            manter_mesma_unidade: this.dados.manter_mesma_unidade,
                            blockrepetir: this.dados.blockrepetir, 
                        }
                    });
                }

            });
            
        }
    }
}
</script>